(() => {
  const init = root => {
    if (root.dataset.reviewReady) return;
    const grid = root.querySelector('[data-review-grid]');
    if (!grid || !grid.children.length) return;
    root.dataset.reviewReady = 'true';
    const cards = [...grid.children];
    let frame = 0;
    const layout = () => {
      frame = 0;
      if (!root.isConnected) return;
      grid.classList.add('is-masonry');
      const style = getComputedStyle(grid);
      const row = parseFloat(style.gridAutoRows);
      const gap = parseFloat(style.rowGap);
      if (!row || !Number.isFinite(gap)) return;
      cards.forEach(card => {
        const height = card.firstElementChild.getBoundingClientRect().height;
        card.style.gridRowEnd = 'span ' + Math.ceil((height + gap) / (row + gap));
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(layout); };
    const observer = new ResizeObserver(schedule);
    cards.forEach(card => observer.observe(card.firstElementChild));
    document.fonts.ready.then(schedule);
    schedule();
    const unload = event => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  document.querySelectorAll('[data-review-grid-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-review-grid-section]').forEach(init));
})();